import {input} from '@ebexco/core/src/services/input';
import {DataStorage} from '@ebexco/core/src/services/storage';
import {defined, getDefinedFallback} from '@ebexco/core/src/utils/defined';
import {empty} from '@ebexco/core/src/utils/strings';
import {derived} from '../../library';
import {Store} from '../../models/Store';

export class InputItem extends Store {
  /**
   * @param {string} name
   * @param {*} [initialValue]
   * @param {DataStorage} [storage]
   */
  constructor(name, initialValue, storage = input) {
    super();
    this.name = name;
    this.storage = storage instanceof DataStorage ? storage : new DataStorage(empty, false, storage);
    this.setStore(getDefinedFallback(storage._data[name], initialValue));
  }

  /**
   * @template T
   * @param {T} value
   * @return {T}
   */
  setter(value) {
    const {name, storage} = this;

    if (defined(value)) {
      storage.setItem(name, value);
    } else {
      this.remove();
    }

    return value;
  }

  remove() {
    const {name, storage} = this;
    this.set(null);
    storage.removeItem(name);
  }
}

/**
 * @type {object.<string, InputItem>}
 */
const stores = {};
const storesAsync = {};

/**
 * @param {string} name
 * @param {*} [initialValue]
 * @param {DataStorage} [storage]
 * @return {InputItem}
 */
export function getInputStore(name, initialValue, storage = input) {
  const context = (storage === input ? stores : storesAsync)[name];

  if (defined(context)) {
    return context;
  } else {
    return (storage === input ? stores : storesAsync)[name] = new InputItem(name, initialValue, storage);
  }
}

/**
 * @param {InputItem} store
 * @param {DataItems} items
 * @return {Array.<Readable.<DataItem>> | Readable.<DataItem>}
 */
export function getInputItemStore(store, items) {
  return derived(store, ($value) => {
    if (Array.isArray($value)) {
      return $value.map((value) => items.getByKey(value) || {});
    } else {
      return items.getByKey($value) || {};
    }
  });
}

